<template>
    <div class="container">
        <b-modal
            :model-value="showDialog"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.newCompany"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog new-company-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <!-- Campo: Nombre -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.name }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="form.name" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="Nombre de la compañía"
                            @blur="validateField('name')"
                        />
                        <span class="error-message" v-if="errors?.name">{{ errors?.name }}</span>
                    </b-col>
                </b-row>

                <!-- Campo: Moneda -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.currency }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="form.idCurrency"
                            class="form-input"
                            @blur="validateField('idCurrency')"
                        >
                            <template #first>
                                <b-form-select-option value="" disabled>
                                    -- {{ labels.selectCurrency }} --
                                </b-form-select-option>
                            </template>
                            <option 
                                :key="currency.id" 
                                :value="currency.id" 
                                v-for="currency in listCurrency"
                            >
                                {{ currency?.nombre }}
                            </option>
                        </b-form-select>
                        <span class="error-message" v-if="errors?.idCurrency">{{ errors?.idCurrency }}</span>
                    </b-col>
                </b-row>

                <!-- Campo: Acrónimo -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.acronym }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="form.acronym" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="Acrónimo de la compañía"
                            @blur="validateField('acronym')"
                        />
                        <span class="error-message" v-if="errors?.acronym">{{ errors?.acronym }}</span>
                    </b-col>
                </b-row>

                <!-- Campo: Código -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.code }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="form.code" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="Código de la compañía"
                        />
                    </b-col>
                </b-row>

                <!-- Campo: NIT -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.identificacion }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="form.identificacion" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="NIT de la compañía"
                            @blur="validateField('identificacion')"
                        />
                        <span class="error-message" v-if="errors?.identificacion">{{ errors?.identificacion }}</span>
                    </b-col>
                </b-row>

                <!-- Campo: Grupo -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.grupo }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="form.id_grupos"
                            class="form-input"
                            @blur="validateField('id_grupos')"
                        >
                            <template #first>
                                <b-form-select-option value="" disabled>
                                    -- {{ labels.selectGroup }} --
                                </b-form-select-option>
                            </template>
                            <option 
                                :key="grupo.id" 
                                :value="grupo.id" 
                                v-for="grupo in listGrupos"
                            >
                                {{ grupo?.nombre }}
                            </option>
                        </b-form-select>
                        <span class="error-message" v-if="errors?.id_grupos">{{ errors?.id_grupos }}</span>
                    </b-col>
                </b-row>

                <!-- Botones de acción -->
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="clicked">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary ml-2" @click="saveCompany" :disabled="isLoading">
                        <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Company from "@/services/Company"
import Currency from "@/services/Currency"
import Grupo from "@/services/Grupo"

export default {
    name: "NewCompany",
    props: ['showDialog'],
    data: () => ({
        form: {
            name: "",
            idCurrency: "",
            acronym: "",
            code: "",
            identificacion: "",
            id_grupos: ""
        },
        listCurrency: [],
        listGrupos: [],
        isLoading: false,
        errors: {
            name: "",
            idCurrency: "",
            acronym: "",
            code: "",
            identificacion: "",
            id_grupos: ""
        }
    }),
    watch: {
        showDialog(val) {
            if (val) {
                this.resetForm()
                this.loadData()
            }
        }
    },
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    newCompany: "Nueva Compañía",
                    name: "Nombre",
                    currency: "Moneda",
                    selectCurrency: "Seleccione una moneda",
                    acronym: "Acrónimo",
                    code: "Código",
                    identificacion: "NIT",
                    grupo: "Grupo",
                    selectGroup: "Seleccione un grupo",
                    save: "Guardar",
                    close: "Cerrar",
                    infoTitle: "Datos de la compañía",
                    infoText: "Completa la información para registrar una nueva compañía."
                }
            } else {
                return {
                    newCompany: "New Company",
                    name: "Name",
                    currency: "Currency",
                    selectCurrency: "Select a currency",
                    acronym: "Acronym",
                    code: "Code",
                    identificacion: "Tax ID",
                    grupo: "Group",
                    selectGroup: "Select a group",
                    save: "Save",
                    close: "Close",
                    infoTitle: "Company information",
                    infoText: "Complete the information to register a new company."
                }
            }
        }
    },
    methods: {
        resetForm() {
            this.form = {
                name: "",
                idCurrency: "",
                acronym: "",
                code: "",
                identificacion: "",
                id_grupos: ""
            }
            this.errors = {
                name: "",
                idCurrency: "",
                acronym: "",
                code: "",
                identificacion: "",
                id_grupos: ""
            }
        },
        validateField(field) {
            const lang = this.$store.state._language
            
            switch(field) {
                case 'name':
                    if (!this.form.name) {
                        this.errors.name = lang == "es-ES" ? "El nombre es obligatorio" : "Name is required"
                    } else if (this.form.name.length < 3) {
                        this.errors.name = lang == "es-ES" ? "El nombre debe tener al menos 3 caracteres" : "Name must have at least 3 characters"
                    } else {
                        this.errors.name = ""
                    }
                    break
                
                case 'idCurrency':
                    if (!this.form.idCurrency) {
                        this.errors.idCurrency = lang == "es-ES" ? "Debe seleccionar una moneda" : "Please select a currency"
                    } else {
                        this.errors.idCurrency = ""
                    }
                    break
                
                case 'acronym':
                    if (!this.form.acronym) {
                        this.errors.acronym = lang == "es-ES" ? "El acrónimo es obligatorio" : "Acronym is required"
                    } else if (this.form.acronym.length < 2) {
                        this.errors.acronym = lang == "es-ES" ? "El acrónimo debe tener al menos 2 caracteres" : "Acronym must have at least 2 characters"
                    } else {
                        this.errors.acronym = ""
                    }
                    break
                
                case 'identificacion':
                    if (!this.form.identificacion) {
                        this.errors.identificacion = lang == "es-ES" ? "El NIT es obligatorio" : "Tax ID is required"
                    } else if (!/^\d{1,20}$/.test(this.form.identificacion)) {
                        this.errors.identificacion = lang == "es-ES" ? "El NIT solo debe contener números" : "Tax ID must contain only numbers"
                    } else {
                        this.errors.identificacion = ""
                    }
                    break
                
                case 'id_grupos':
                    if (!this.form.id_grupos) {
                        this.errors.id_grupos = lang == "es-ES" ? "Debe seleccionar un grupo" : "Please select a group"
                    } else {
                        this.errors.id_grupos = ""
                    }
                    break
            }
        },
        validateForm() {
            this.validateField('name')
            this.validateField('idCurrency')
            this.validateField('acronym')
            this.validateField('identificacion')
            this.validateField('id_grupos')
            
            return !this.errors.name && 
                   !this.errors.idCurrency && 
                   !this.errors.acronym && 
                   !this.errors.identificacion && 
                   !this.errors.id_grupos
        },
        clicked() {
            this.$emit('clicked', false)
        },
        async saveCompany() {
            if (!this.validateForm()) {
                this.$toast.error(this.$store.state._language == "es-ES" 
                    ? "Por favor, corrija los errores del formulario" 
                    : "Please correct the form errors")
                return
            }
            
            this.isLoading = true
            try {
                const companyData = {
                    name: this.form.name,
                    idCurrency: this.form.idCurrency,
                    acronym: this.form.acronym,
                    code: this.form.code || null,
                    identificacion: this.form.identificacion,
                    id_grupos: this.form.id_grupos,
                    userId: this.$store.state.userId,
                    estado: 1
                }
                const result = await Company.createCompany(companyData)
                
                this.$toast.success(result.data.message || (this.$store.state._language == "es-ES" 
                    ? "Compañía creada exitosamente" 
                    : "Company created successfully"))
                
                this.$emit('companyCreated', true)
                this.clicked()
            } catch (error) {
                console.error("Error creating company:", error)
                
                let errorMessage = this.$store.state._language == "es-ES" 
                    ? "Error al crear la compañía" 
                    : "Error creating company"
                
                if (error.response && error.response.data) {
                    if (error.response.data.message) {
                        errorMessage = error.response.data.message
                    } else if (error.response.data.error) {
                        errorMessage = error.response.data.error
                    }
                }
                
                this.$toast.error(errorMessage)
            } finally {
                this.isLoading = false
            }
        },
        async loadData() {
            try {
                const [currencyRes, grupoRes] = await Promise.all([
                    Currency.getAllCurrency(),
                    Grupo.getAllGrupos()
                ])
                
                this.listCurrency = currencyRes.data.currency || []
                this.listGrupos = grupoRes.data.grupos || []
            } catch (error) {
                console.error("Error loading data:", error)
                this.$toast.error(this.$store.state._language == "es-ES" 
                    ? "Error al cargar los datos" 
                    : "Error loading data")
            }
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>

<style src="../main.css"></style>